import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import Staff, { StaffFormPayload } from 'types/staff'
import { mergeURL } from './lib'
import { serialize } from 'object-to-formdata'
const resource = 'staffs'

export const requests = {
  fetchStaffs: () => {
    return axiosForGigbaseBiz.get<DataResponse<Staff[]>>(resource)
  },
  fetchIndex: async (page?: number, limit?: number) => {
    return await axiosForGigbaseBiz.get<DataResponse<Staff[]>>(resource, {
      params: {
        page,
        limit,
      },
    })
  },
  fetchDetail: async (id: string) => {
    return await axiosForGigbaseBiz.get<DataResponse<Staff>>(
      mergeURL(resource, id.toString()),
    )
  },
  create: async (payload: StaffFormPayload) => {
    return await axiosForGigbaseBiz.post<DataResponse<Staff>>(
      resource,
      serialize(payload),
    )
  },
  update: async (id: string, payload: StaffFormPayload) => {
    return await axiosForGigbaseBiz.patch<DataResponse<Staff>>(
      mergeURL(resource, id.toString()),
      serialize(payload),
    )
  },
  delete: async (id: number) => {
    return await axiosForGigbaseBiz.delete<DataResponse>(
      mergeURL(resource, id.toString()),
    )
  },
}
